// recova GmbH – Login (nur Mitarbeiter; Registrierung erfolgt durchs Backoffice).
import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth, ROLE_HOME } from "@/App";
import { API, fmtErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Recycle } from "lucide-react";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const user = await login(form.email, form.password);
      toast.success(`Willkommen, ${user.name}!`);
      navigate(location.state?.from || ROLE_HOME[user.role] || "/");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#1b4332] px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-flex items-center gap-2" data-testid="login-logo">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white p-0.5"><img src="/logo.png" alt="recova Logo" className="h-11 w-11 rounded-full object-cover" data-testid="logo" /></div>
            <span className="font-heading text-2xl font-extrabold text-white">recova</span>
          </Link>
          <p className="mt-2 text-sm text-emerald-100/70">Service-Plattform – Mitarbeiter-Login</p>
        </div>
        <div className="rounded-2xl bg-white p-8 shadow-2xl" data-testid="login-card">
          <form onSubmit={submit} className="space-y-4">
            <div><Label htmlFor="email">E-Mail</Label><Input id="email" type="email" data-testid="login-email" className="mt-1.5" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /></div>
            <div><Label htmlFor="password">Passwort</Label><Input id="password" type="password" data-testid="login-password" className="mt-1.5" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required /></div>
            {error && <p className="rounded-lg bg-red-50 p-3 text-sm font-medium text-red-600" data-testid="auth-error">{error}</p>}
            <button type="submit" className="btn-primary w-full py-3" disabled={busy} data-testid="login-submit">
              {busy ? "Bitte warten…" : "Anmelden"}
            </button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-emerald-100/50"><Link to="/" className="hover:underline">← Zurück zur Website</Link></p>
      </div>
    </div>
  );
}
